// components/public/lead-return-flag.ts
// Shared by the two client-side lead forms (LeadCaptureForm, TaxRemindersForm):
// reads the ?subscribed=1 / ?leadError=1 return flag the native (no-JS) POST
// redirects back with. Moved verbatim out of LeadCapture.tsx; no behavior change.

import { leadReturnStatusFromHref } from "@/lib/lead-request";

export function subscribeLeadReturnFlag(onStoreChange: () => void) {
  window.addEventListener("popstate", onStoreChange);
  return () => window.removeEventListener("popstate", onStoreChange);
}

export function getLeadReturnFlag() {
  return leadReturnStatusFromHref(window.location.href);
}

export function getLeadReturnFlagServer(): ReturnType<typeof leadReturnStatusFromHref> {
  return null;
}
